import ServiceCRUD from '../../../../services/ServiceGasOrder';

class AreaService extends ServiceCRUD {
  constructor() {
    super(`/api/areas`);
  }
}

export default new AreaService();
